import api from '../../utils/api'
import ADPRefcodeService from '../admin/ADPRefcodeService';

const API_BASE_URL = "/ast/ASTLogqr";

const ASTLogqrService = {
  async findAll(recordFilter: any): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-all`, {
      params: recordFilter,
    });
    return response.data;
  },

  async getItemById(instrumentId: any): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-one/${instrumentId}`);
    return response.data;
  },

  async create(item: any): Promise<any> {
    const response = await api.post(`${API_BASE_URL}/create`, item);
    return response.data;
  },

  async update(instrumentId: string, item: any): Promise<any> {
    const response = await api.put(`${API_BASE_URL}/update/${instrumentId}`, item);
    return response.data;
  },

  async getItemByFacilityCode(facilityCode: any): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/get-dropdown-by-facility-code/${facilityCode}`);
    return response.data;
  },

  async getDropdown(moduleId: string, referenceGroup: string): Promise<any> {
    return await ADPRefcodeService.getDropdownByModuleIdAndReferencegroup(moduleId, referenceGroup);
  },

  async getEquipmentTypesByEntity(moduleId: string, referenceGroup: string, value1: string): Promise<any> {
    return await ADPRefcodeService.getDropdownByModuleIdAndReferencegroupAndValue1(moduleId, referenceGroup, value1);
  },


};



export default ASTLogqrService;